import MovieConsumptionWrapper, {
  getServerSideProps
} from '../../../movies/details/[movieTitle]/[movieId]';

export { getServerSideProps };
export default MovieConsumptionWrapper;
